import { createSelector } from 'reselect';

import { Party } from 'types/service';
import { ServiceOptions } from '@tock/shared/constants/ServiceConstants';
import { StoreType } from '@tock/shared/utils/connect';
import { includes, isEmpty } from 'es-toolkit/compat';
import { isPartyWalkIn } from 'utils/partyUtils';
import { selectedPartyListServicesSelector } from 'selectors/calendarFilterSelectors';
import { selectedPartySelector } from 'selectors/service/selectedPartySelector';
import activeServicesSelector from 'selectors/service/activeServicesSelector';

export const serviceSelector = createSelector(
  (state: StoreType) => state.service,
  (service: StoreType['service']) => service
);

export const serviceShowBookingModalSelector = createSelector(
  (state: StoreType) => state.service.ui,
  selectedPartySelector,
  (ui: StoreType['service']['ui'], selectedParty?: Party): boolean => {
    const showAProfileModal = !!selectedParty && ui.showProfile;
    const isWalkin = !!selectedParty && isPartyWalkIn(selectedParty);
    return showAProfileModal && !isWalkin;
  }
);

export const showWalkInModalSelector = createSelector(
  (state: StoreType) => state.service.ui,
  selectedPartySelector,
  (ui: StoreType['service']['ui'], selectedParty?: Party): boolean => {
    const showAProfileModal = !!selectedParty && ui.showProfile;
    const isWalkin = isPartyWalkIn(selectedParty);
    return showAProfileModal && isWalkin && !!selectedParty;
  }
);

export const calendarServiceSelector = createSelector(
  selectedPartyListServicesSelector,
  activeServicesSelector,
  (partyListServices: number[], activeServices: string[]): string[] => {
    if (isEmpty(partyListServices) || includes(partyListServices, null)) {
      return activeServices;
    }

    return partyListServices.sort().map((value: number) => ServiceOptions[value].key as string);
  }
);
